export default "__VITE_ASSET__BPRSgH_E__"